import type { AdminAuditEntry } from '@steado/admin-contract/activity';

/**
 * One line of what the entry's metadata says.
 *
 * Every writer records a different shape on purpose, so this reads the few keys
 * that recur — a name, a reason — and otherwise says how many fields there are
 * rather than dumping JSON into a table cell.
 */
export function summarise(entry: AdminAuditEntry): string | null {
  const metadata = entry.metadata;
  if (typeof metadata !== 'object' || metadata === null || Array.isArray(metadata)) return null;

  const record = metadata as Record<string, unknown>;
  const parts: string[] = [];

  if (typeof record.name === 'string') parts.push(record.name);
  if (typeof record.reason === 'string') parts.push(`“${record.reason}”`);
  if (typeof record.intoName === 'string') parts.push(`→ ${record.intoName}`);
  if (record.applied === false) parts.push('no change');

  if (parts.length > 0) return parts.join(' · ');

  const keys = Object.keys(record);
  if (keys.length === 0) return null;

  return `${String(keys.length)} field${keys.length === 1 ? '' : 's'}: ${keys.slice(0, 3).join(', ')}`;
}
